/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "backbone",
    "editors/adder/js/model",
    "i18n/i18n",
    "underscore"
  ],
  function(
    Backbone,
    AdderGroups,
    i18n,
    _
  ) {

    var compareByWeight = function (a, b) {
      if (_.isNumber(a.weight) && _.isNumber(b.weight)) {
        return a.weight - b.weight;
      }

      if (_.isNumber(a.weight)) return -1;

      return 1;
    };

    var TemplateRegistry = function () {
      this.templateTypes = {};
    };

    _.extend(TemplateRegistry.prototype, Backbone.Events, {

        add: function (templateType) {
          this.templateTypes[templateType.id] = templateType;
        },

        getAdders: function (context, application) {
          var that = this,
              adderGroups = new AdderGroups(),
              sortedIds = _.pluck(_.values(this.templateTypes).sort(compareByWeight), "id");

          _.forEach(sortedIds, function (id) {
              var templateType = that.templateTypes[id];
              if (templateType.on) {
                templateType.on("changed", function () {
                  updateAdderGroups(adderGroups, templateType, context, application);
                });
              }
              updateAdderGroups(adderGroups, templateType, context, application);
          });

          return adderGroups;
        },

        create: function (id, options) {
          var templateType = this.templateTypes[id];
          if (!templateType) return null;

          return templateType.create(options);
        }
    });

    // groups are identified by their name (translated)
    // multiple template types can be contained in one group
    function updateAdderGroups(adderGroups, templateType, context, application) {
      var entries = _.collect(templateType.getAdders(context, application), function (adderEntry) {
          return _.extend({
              templateType: templateType.id
            }, adderEntry);
      });
      // This is used to group the different components in one adder, eg. Pager and Pagination are added to Pager group
      var groupId = i18n( templateType.name  || templateType.id );

      var groupUid = templateType.id ||  templateType.name;
      var currentGroup = adderGroups.get(groupId);
      var existingAdders;
      var adders = new AdderGroups.Adders();
      var currentPosition = adderGroups.reduce(function (position, group, index) {
        if (position >= 0) return position;
        if (group.get("id") === groupId) {
          return index;
        }
        return position;
      }, -1);

      if (groupId) {
        adderGroups.remove(groupId);
      }

      if (currentGroup) {
        existingAdders = currentGroup.get("adders");
        // copy all adders of other types
        adders.add(existingAdders.filter(function (adder) { return adder.get("templateType") !== templateType.id; }));
      }

      var options = {};
      if (currentPosition >= 0) {
        options.at = currentPosition;
      }
      if (entries && entries.length) {
        adders.add(entries);
        adderGroups.add({
            id: groupId,
            groupId: groupUid,
            name: templateType.name || templateType.id,
            description: templateType.description,
            adders: adders
          }, 
          options);
      }
    }

    var templateRegistry = new TemplateRegistry();

  // TODO: don't make global, add to application instead
  return templateRegistry;
});
